export default "__VITE_PUBLIC_ASSET__c111d344__"